import React, { useState, useEffect } from "react";
import KYCModal from "./kycModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import cookie from "react-cookies";
import { CLIQ_BASE_URL, UNIFIED_BASE_URL, WEB_BASE_URL } from "../../webbase";

const WhiteLabelRequests = ({ navigate }) => {
    const [userEmail, setUserEmail] = useState(cookie.load("user"));
    const [token, setToken] = useState(cookie.load("token"));
    const [users, setUsers] = useState([]);
    const [formEmail, setFormEmail] = useState("");
    const [formRole, setFormRole] = useState("");

    const onInviteUser = (event) => {
        event.preventDefault();
        if (formEmail !== "" && formRole !== "") {
            toast.success("User Role Edited!!!");
        } else {
            toast.error("User Role Edit failed!!!");
        }
    };

    const handleKYCSubmit = (data) => {
        const id = toast.loading("Processing KYC request...");
        axios.post(UNIFIED_BASE_URL + "/onboarding/update-kyc-status", data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
        .then((res) => {
            if (res.data.status === "2000") {
                toast.update(id, {
                    render: `Successfully ${data.status} KYC Request`,
                    type: "success",
                    isLoading: false,
                });
                getUsers(); // Refresh the list
            } else {
                toast.update(id, {
                    render: res.data.description,
                    type: "error",
                    isLoading: false,
                });
            }
        })
        .catch((err) => {
            console.log(err);
            toast.update(id, {
                render: "Error processing KYC request",
                type: "error",
                isLoading: false,
            });
        })
        .finally(() => {
            setTimeout(() => {
                toast.dismiss();
            }, 2000);
        });
    };

    const approve = ({ dsp, emailAddress, network, secret }) => {
        const id = toast.loading("Please wait...");
        const data = {
            "defaultAccBalance": 0,
            "dsp": dsp,
            "emailAddress": emailAddress,
            "network": network,
            "secret": secret
        };
        console.log(data);
        axios.post(UNIFIED_BASE_URL + "/manage/approve-mobile-request", data, {
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
        .then((res) => {
            if (res.data.status === "2000") {
                toast.update(id, {
                    render: "Successfully Approved Mobile App Request",
                    type: "success",
                    isLoading: false,
                });
                window.location.reload();
            } else {
                toast.update(id, {
                    render: res.data.description,
                    type: "error",
                    isLoading: false,
                });
            }
        })
        .catch((err) => {
            console.log(err);
            toast.update(id, {
                render: "Error Approving Mobile App Request",
                type: "error",
                isLoading: false,
            });
        })
        .finally(() => {
            setTimeout(() => {
                toast.dismiss();
            }, 2000);
        });
    };

    const getUsers = () => {
        axios
            .get(UNIFIED_BASE_URL + "/onboarding/get-all-kyc", {
                headers: {
                    authorization: token,
                },
            })
            .then((res) => {
                console.log(res.data.data);
                setUsers(res.data.data);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString();
    };

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <main className="page-content">
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <a href="javascript:;">
                                    <i className="bx bx-home-alt"></i>
                                </a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                WhiteLabels
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0">All Requests for Mobile App</h5>
                        <form className="ms-auto position-relative">
                            <div className="position-absolute top-50 translate-middle-y search-icon px-3">
                                <i className="bi bi-search"></i>
                            </div>
                            <input
                                className="form-control ps-5"
                                type="text"
                                placeholder="search"
                            />
                        </form>
                    </div>
                    <div className="table-responsive mt-3">
                        <table className="table align-middle">
                            <thead className="table-secondary">
                                <tr>
                                    <th>ID</th>
                                    <th>Business Name</th>
                                    <th>Logo</th>
                                    <th>App Name</th>
                                    <th>Email</th>
                                    <th>Support Contact</th>
                                    <th>Status</th>
                                    <th>Date Created</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users?.map((user, index) => (
                                    <React.Fragment key={index}>
                                        <tr>
                                            <td>{user?.id}</td>
                                            <td>{user?.businessName}</td>
                                            <td>{user?.imageUrl && (
                                                        <a
                                                            href={user?.imageUrl}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-primary"
                                                            title="View Image"
                                                        >
                                                            <i className="bi bi-image"></i> 
                                                        </a>
                                                    )}
                                                </td>
                                            <td>{user?.appName || "Not set"}</td>
                                            <td>{user?.emailAddress}</td>
                                            <td>
                                                {user?.supportEmail && (
                                                    <div>Email: {user?.supportEmail}</div>
                                                )}
                                                {user?.supportPhoneNumber && (
                                                    <div>Phone: {user?.supportPhoneNumber}</div>
                                                )}
                                            </td>
                                            <td>
                                                <span className={`badge bg-${user?.status === "Pending" ? "warning" : user?.status === "approve" ? "success" : "danger"}`}>
                                                    {user?.status}
                                                </span>
                                            </td>
                                            <td>{formatDate(user?.dateCreated)}</td>
                                            <td>
                                                <div className="table-actions d-flex align-items-center gap-3 fs-6">
                                                    {/* {user?.status === "Pending" && ( */}
                                                        <button
                                                            className="btn btn-sm btn-primary"
                                                            data-bs-toggle="modal"
                                                            data-bs-target={`#kycModal${user.id}`}
                                                        >
                                                            Review KYC
                                                        </button>
                                                    {/* )} */}
                                                    
                                                </div>
                                            </td>
                                        </tr>
                                        <KYCModal
                                            id={`kycModal${user.id}`}
                                            onSubmit={handleKYCSubmit}
                                            title="Review KYC Request"
                                            emailAddress={user?.emailAddress}
                                        />
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default WhiteLabelRequests;
